<template>
  <div>
    <div class="tabsBox">
      <van-tabs
        v-model="active"
        class="meusTabs"
        animated
        sticky
        offset-top="1.2rem"
        lazy-render
      >
        <van-tab
          v-for="item in meusList"
          :key="item"
          :title="item"
        />
      </van-tabs>
    </div>
    <div class="data_box">
      <div class="top_data_box">
        <div
          v-for="item in dataParams"
          :key="item.key"
          class="data_item"
        >
          <div class="title">
            {{ item.title }}
          </div>
          <div class="count">
            {{ data.direct[item.key] === 0 || data.direct[item.key] ? data.direct[item.key] : '-' }}
          </div>
        </div>
        <div class="bottom_data_box">
          <div class="title">
            {{ $t("数据概览") }}
          </div>
          <div
            v-for="item in dataList"
            :key="item.title"
            class="data_row_box"
          >
            <div
              class="data_row_title"
              @click="changeActive(item.active)"
            >
              {{ item.title }}
            </div>
            <div class="data_col_box">
              <div
                v-for="citem in item.colList"
                :key="citem.title"
                class="data_col"
              >
                <div class="data_col_title">
                  {{ citem.title }}
                </div>
                <div class="data_col_count">
                  {{ data.summary[citem.key] || data.summary[citem.key] === 0 ?
                    data.summary[citem.key] : '-' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Tab, Tabs } from 'vant';
import Fetch from '../../../utils/fetch';
export default {
    components: {
        vanTab: Tab,
        vanTabs: Tabs,
    },
    data() {
        return {
            active: 0,
            data: {
                direct: {},
                summary: {}
            },
            meusList: [this.$t("昨天"), this.$t("今天"), this.$t("本星期"), this.$t("上星期"), this.$t("本月"), this.$t("上个月")],
            dateList: ['yesterday', 'today', 'week', 'last week', 'month', 'last month'],
            dataParams: [
                {
                    title: this.$t("首次存款金额"),
                    key: 'first_recharge_money'
                },
                {
                    title: this.$t("首次存款"),
                    key: 'first_recharge_num'
                },
                {
                    title: this.$t("存款"),
                    key: 'recharge_money'
                },
                {
                    title: this.$t("有效投注"),
                    key: 'total_bet'
                },
                {
                    title: this.$t("获得奖励"),
                    key: 'reward_money'
                },
                {
                    title: this.$t("佣金总额"),
                    key: 'commission'
                },
            ],
            dataList: [
                {
                    title: this.$t("我的团队"),
                    active: 5,
                    colList: [
                        {
                            title: this.$t("团队规模"),
                            key: 'total_user_num'
                        },
                        {
                            title: this.$t("直接会员"),
                            key: 'direct_user_num'
                        },
                        {
                            title: this.$t("其他会员"),
                            key: 'other_user_num'
                        },
                    ]
                },
                // {
                //     title: 'Desempenho',
                //     active: 3,
                //     colList: [
                //         {
                //             title: 'Rendimento Total',
                //             key: 'allVaildAmount'
                //         },
                //         {
                //             title: 'D. Direto',
                //             key: 'directlyVaildAmount'
                //         },
                //         {
                //             title: 'D. dos Outros',
                //             key: 'otherVaildAmount'
                //         },
                //     ]
                // },
                // {
                //     title: 'Comissão',
                //     active: 4,
                //     colList: [
                //         {
                //             title: 'Comissão Total',
                //             key: 'allCommissionAmount'
                //         },
                //         {
                //             title: 'Comissão Direta',
                //             key: 'directlyCommissionAmount'
                //         },
                //         {
                //             title: 'Outra Comissão',
                //             key: 'otherCommissionAmount'
                //         },
                //     ]
                // },
            ]
        }
    },
    watch: {
        active(newval) {
            this.getList(this.dateList[newval])
        }
    },
    created() {
        this.getList()
    },
    methods: {
        getList(timeType) {
            Fetch('/agent/myData', {
                date: timeType || this.dateList[0]
            }).then(res => {
                // this.data = res.data
                this.$set(this, 'data', res.data)
            })
        },
        changeActive(key) {
            this.$emit('changeActive', key)
        }
    }
}
</script>
<style lang="less" scoped>
@import '../../../assets/css/variables.less';

.tabsBox {
    background-color: @secondary-color;
    padding: 0.2rem 0.2rem 0.1rem;

    :deep(.van-tab) {
        border: 1px solid @third-color;
        border-radius: 1rem;
        padding: 0 0.3rem !important;
        margin: 0 0.1rem;
        height: 0.7rem;

        &.van-tab--active {
            background-color: @rechargeColor;

            span {
                color: @primary-color !important;
            }
        }
    }

    :deep(.van-tabs__line) {
        display: none;
    }
}

.data_box {
    margin-top: 0.1rem;
    padding: 0.2rem;

    .top_data_box {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .data_item {
            width: 31.5%;
            height: 2rem;
            background-color: @secondary-color;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: @textcolor1;
            font-size: 0.32rem;
            text-align: center;
            margin-bottom: 0.28rem;
            border-radius: 0.2rem;
            padding: 0.2rem;
            box-sizing: border-box;
            box-shadow: 0 .03rem .09rem 0 rgba(0, 0, 0, .06);

            .title {
                margin-bottom: 0.36rem;
            }

            .count {
                font-size: 0.46rem;
                color: @textcolorf;
            }

            &:last-child {
                .count {
                    color: @rechargeColor;
                }
            }
        }
    }

    .bottom_data_box {
        // margin-top: 0.12rem;
        width: 100%;
        border-radius: 0.2rem;
        background-color: @secondary-color;

        .title {
            color: @textcolorf;
            padding: 0 0.2rem;
            height: 1.07rem;
            line-height: 1.07rem;
            border-bottom: 1px solid @bodercolor;
        }

        .data_row_box {
            padding: 0 0.2rem;

            .data_col_box {
                display: flex;
                border-bottom: 1px solid @bodercolor;
            }

            &:last-child {
                .data_col_box {
                    border-bottom: none;
                }

                .data_col_count {
                    color: @anttextcolor !important;
                }
            }

            .data_row_title {
                position: relative;
                height: 0.8rem;
                line-height: 0.8rem;
                color: @textcolor1;
                text-align: center;
                border-bottom: 1px solid @bodercolor;

                &::before {
                    content: '';
                    border-color: @textcolor1;
                    border-style: solid;
                    border-width: .01rem .01rem 0 0;
                    content: "";
                    display: block;
                    height: .15rem;
                    position: absolute;
                    right: .2rem;
                    top: 50%;
                    transform: translate(-50%, -50%) rotate(45deg);
                    width: .15rem;
                }
            }

            .data_col {
                position: relative;
                width: 32%;
                display: flex;
                flex-direction: column;
                align-items: center;
                height: 1.2rem;
                padding: 0.2rem 0;
                font-size: 0.32rem;
                color: @textcolor1;

                .data_col_count {
                    margin-top: 0.32rem;
                    color: @textcolorf;
                }

                &::before {
                    content: '';
                    width: 1px;
                    height: 40px;
                    position: absolute;
                    right: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    background-color: @third-color;
                }

                &:last-child {
                    &::before {
                        display: none;
                    }
                }
            }
        }
    }
}
</style>